<template>
    <div class="person-right">
        <div class="maintop">
            <span>我的申请</span>
        </div>
        <el-divider></el-divider>
        <div>
            <el-button v-if="showAddBtn" type="primary"  @click='addApply()'>立刻申请</el-button>
            <div class="person-applys" v-for="(item, index) in applylist" :key="index">
                <el-divider></el-divider>
                <div class="person-apply">
                    <el-row>
                        <el-col :span="5">
                            <div class="person-apply-img">
                                <img :src="item.roomPhoto?item.roomPhoto:require('../../assets/imgs/banner.jpg')">
                            </div>                            
                        </el-col>
                        <el-col :span="19">
                            <div class="person-apply-content">
                                <el-col :span="10">
                                    <div class="person-applyl">
                                        <div class="person-applyl-info">
                                            <p class="person-applyl-title">{{item.communityName}}{{item.roomKindsName}}</p>
                                            <p class="person-applyl-price" v-if="item.rental">￥{{item.rental}}/月</p>
                                            <p class="person-applyl-price" v-else></p>
                                            <div>
                                                <span class="person-applyl-tip">申请日期：</span>
                                                <span>{{item.applyDate | datetime}}</span>
                                            </div>
                                            <div style="margin-top:8px">
                                                <span class="person-applyl-tip">当前状态：</span>
                                                <span :class="color">{{item.statusName}}</span>
                                            </div>                                        
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="14">
                                    <div class="person-applyr">
                                        <el-button type="info" plain v-if="!item.editable" @click="onEdit(item.applyID)">查看详情</el-button>
                                        <el-button v-if="item.editable" type="danger" @click="onEdit(item.applyID)">
                                            {{item.isExtend ? "修改续租信息" : "修改申请信息"}}
                                        </el-button>
                                        <el-button v-if="!item.editable && item.status == 10 &&item.isOverdue!=1" type="warning" @click="onEditCommunity(item)">
                                            变更意向
                                        </el-button>
                                         <el-button v-if="item.isCanSupply && !item.editable" type="primary" @click="onAddApplyInfo(item.applyID)">
                                            补交资料
                                        </el-button>
                                        <el-button v-if="item.isCanAddCoapplicant && !item.editable" type="primary" @click="onAddApplyCoapplicant(item.applyID)">
                                            增加同住人
                                        </el-button> 
                                        <el-button v-if="item.status==10 &&item.isOverdue==1" @click="reApply(item)" type="danger">
                                            重新申请
                                        </el-button>
                                        <el-button v-if="item.editable && (item.status == 0 || item.status == 2 || item.status == 25) && !item.isExtend" type="danger" @click="onDeleteApplyInfo(item.applyID)">
                                            取消申请
                                        </el-button>
                                        <el-button v-if="item.status == 10 &&item.isOverdue!=1" type="danger" @click="abandon(item)">
                                            放弃准入
                                        </el-button>
                                        <!-- <el-button v-if="!item.editable && (item.status == 2 || (item.isExtend))" type="primary" @click="onPrintAccessTable(item.applyID)">
                                            {{item.isExtend ? "打印续租资格准入申请单" : "打印资格准入申请单"}}
                                        </el-button> -->
                                    </div>
                                </el-col>
                            </div>
                            <div class="person-apply-info">
                                <div v-if="item.applyNotApproveReason!=''">
                                    <div style="margin-top:8px">
                                        <span class="person-applyl-tip">{{item.statusName}}原因：</span>
                                        <span :class="color">{{item.applyNotApproveReason}}</span>
                                    </div>
                                </div>
                                <div v-if="item.status == 10 && item.isOverdue == 1">
                                    <div style="margin-top:8px">
                                        <span class="person-applyl-tip" style="color:red;">您的准入资格已过期，您可以在一个月内完成重新申请并通过资格审核，以保留当前排号。逾期自动终止申请。</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        
                    </el-row>
                </div>                
            </div>
        </div>

        <!--修改小区户型-->
        <el-dialog id="edit-community"
                   title="修改意向小区和户型"
                   :visible.sync="editCommunityShow"
                   width="25%"
                   :center="false"
                   top="20vh"
                   :close-on-click-modal="false"
                   :lock-scroll="false">
            <el-form :model="intentForm" :rules="intentRules" ref="intentForm">
                <el-row style="margin-bottom: 15px">
                    <el-col align="left" v-if="intentForm.sortNum != '' && intentForm.sortNum != -1">
                        <span style="color:red">您当前排在：{{intentForm.sortNum}}号，变更小区或户型将重新排队</span>
                    </el-col>
                    <el-col align="left" v-else>
                        <span style="color:red">注意：变更小区或户型将重新排队</span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" align="right">
                        <el-form-item  label="租赁方式：" prop="rentType">
                            <el-select @change="ChangeRentType" v-model="intentForm.rentType" style="width:70%">
                                <el-option
                                    v-for="item in rentwayList"
                                    :key="item.enumValue"
                                    :label="item.enumText"
                                    :value="item.enumValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" align="right">
                        <el-form-item label="街道：" prop="streettown">
                            <el-select no-data-text="请选择街道" @change="ChangeStreetTown" v-model="intentForm.streettown" style="width:70%">
                                <el-option v-for="item in streettownlist"
                                           :key="item.code"
                                           :label="item.name"
                                           :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" align="right">
                        <el-form-item label="小区：" prop="communityID">
                            <el-select no-data-text="请选择小区" @change="changeCommunity" v-model="intentForm.communityID" style="width:70%">
                                <el-option v-for="item in communitylist"
                                           :key="item.id"
                                           :label="item.name"
                                           :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" align="right">
                        <el-form-item label="房型：" prop="roomKindID">
                            <el-select no-data-text="请选择房型" @change="changeRoomKind" v-model="intentForm.roomKindID" style="width:70%">
                                <el-option v-for="item in roomlist"
                                           :key="item.kindID"
                                           :label="item.kindName"
                                           :value="item.kindID">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-button type="danger" style="width: 100%" @click="editCommunity()">确定修改</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog id="account-pwd"
                   title=""
                   :visible.sync="warnningShow"
                   width="20%"
                   :center="false"
                   top="20vh"
                   :close-on-click-modal="false"
                   :lock-scroll="false">
            <el-form>
                <el-row>
                    <div>
                        <img :src="require('../../assets/imgs/code_ico1.jpg')" style="width:100%;height:100%;" />
                    </div>
                </el-row>
                <el-row>
                    <span style="font-weight: bold;font-size: 16px; color: red;">尊敬的租户，请扫码登录公众号完成该操作!</span>
                </el-row>
                <el-row>
                    <el-col>
                        <el-button type="primary" style="width: 100%;margin-top:15px;" @click="closeWarn()">关 闭</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import UserApi from "@/api/user/index";
    import PortalApi from "@/api/portal/index";
    import { getUserInfo} from "@/store/index";
    //let moment = require("moment");
    export default {
        data() {
            return {
                warnningShow: false,
                editCommunityShow: false,
                applylist: [],
                curApply: {},
                color: '',
                streettownlist: [],
                communitylist: [],
                roomlist: [],
                rentwayList:[],
                applyStatus: "",
                applyID: null,
                applyOutID: null,

                intentForm: {
                    applyID: "",
                    streettown: "",
                    communityID: "",
                    roomKindID: "",
                    rentType: 0,
                    sex: null,
                    sortNum: "",
                    rentType:"",
                    maritalStatus:""
                },
                intentRules: {
                    rentType:[
                        {
                            required: true,
                            message: "租赁方式不能为空",
                            trigger: "change"
                        }
                    ],
                    streettown: [
                        {
                            required: true,
                            message: "街道不能为空",
                            trigger: "change"
                        }
                    ],
                    communityID: [
                        {
                            required: true,
                            message: "小区不能为空",
                            trigger: "change"
                        }
                    ],
                    roomKindID: [
                        {
                            required: true,
                            message: "户型不能为空",
                            trigger: "change"
                        }
                    ],
                },
                userInfo:{},
                showAddBtn:false
            }
        },
        methods: {
            // onApply(item){
            //     this.$confirm('重新申请只能申请，<span style="color:red; font-weight:bold;">'+item.communityName+"："+item.roomKindsName+'</span>，确定重新申请？', '提示', {
            //             distinguishCancelAndClose: true,
            //             confirmButtonText: '确定',
            //             cancelButtonText: '取消'
            //         }).then(() => {
            //             this.$router.push({ path: '/Apply', query: { id: item.applyID } })
            //     })
            // },
            getRentwayType(){
                this.rentwayList = this.$Global.enum.RentType;
            },
            showChange(id) {
                this.currentNav = id
            },
            getStreetTownList() {
                this.streettownlist = this.$Global.syscode.StreetTownList;
            },
            getApplyList() {
                UserApi.getApplyList()
                    .then(
                        (res) => {
                            this.applylist = res.data;
                            for (var i = 0; i < this.applylist.length; i++) {
                                if (this.applylist[i].statusName == '待提交' || this.applylist[i].statusName == '修改再受理')
                                    this.color = 'grey'
                                else if (this.applylist[i].statusName == '终止' || this.applylist[i].statusName == '解除' || this.applylist[i].statusName == '不通过' || this.applylist[i].statusName == '退回')
                                    this.color = 'red'
                                else
                                    this.color = 'bule'
                            }
                            this.getStreetTownList()
                            this.getRentwayType()

                            var isShowAddApply = true;
                            if(this.applylist != null && this.applylist.length > 0){
                                for(var i = 0;i<this.applylist.length;i++){
                                    if(this.applylist[i].status != 21){
                                        isShowAddApply = false;
                                        return false;
                                    }
                                }
                            }
                            this.showAddBtn = isShowAddApply;
                        },
                        (err) => {
                            this.$message({
                                message: err,
                                center: true,
                            });
                        }
                    )
                    .catch((error) => {
                        this.$message({
                            message: error,
                            center: true,
                        });
                    });
            },
            onEdit(id) {
                this.$router.push({ path: '/Apply', query: { id: id } })
            },
            onDeleteApplyInfo(id) {
                this.$confirm('确定取消申请，取消后不可恢复，是否继续？', '系统提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    UserApi.deleteRentApply({ applyId: id })
                        .then((res) => {
                            if (res.data) {
                                this.$message({
                                    message: "取消申请成功",
                                    type: "success",
                                    center: true,
                                });
                                // 刷新下列表
                                this.getApplyList();
                            }
                        }
                            ,
                            (err) => {
                                this.$message({
                                    message: err,
                                    type: "error",
                                    center: true,
                                });
                            }
                        )
                        .catch((error) => {
                            this.$message({
                                message: error,
                                type: "error",
                                center: true,
                            });
                        });
                });
            },
            onAddApplyInfo(id) {
                this.$router.push({ path: '/Apply/ApplyInfoSupply', query: { id: id } })
            },
            onAddApplyCoapplicant(id){
                this.$confirm('若主申请人的父母、公婆或者岳父母需办理同住，可直接在公租房管家处办理入住登记，无需在此申请添加', '提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.$router.push({ path: '/Apply/ApplyPersonChange', query: { id: id } })
                })
                
            },
            onEditCommunity(item) {
                this.curApply = item;
                this.intentForm.applyID = item.applyID;
                this.intentForm.communityID = item.communityID;
                this.intentForm.roomKindID = item.roomKindID;
                this.intentForm.streettown = item.streetTown;
                this.intentForm.rentType = item.rentType;
                this.intentForm.sex = item.sex;
                this.intentForm.maritalStatus = item.maritalStatus;
                this.intentForm.sortNum = null;
                this.editCommunityShow = true;

                // 获取当前排号
                UserApi.getWaitingInfo().then(res => {
                    this.intentForm.sortNum = res.data.sortNum;
                })

                // 获取小区列表
                PortalApi.getEditCommunitys(item.applyID, item.streetTown)
                    .then(
                        (res) => {
                            this.communitylist = res.data;

                            PortalApi.getIntentRoomKinds(item.communityID, item.rentType)
                                .then(
                                    (kinds) => {
                                        this.roomlist = kinds.data;
                                        var roomKind = this.roomlist.filter(function (ele) { return ele.kindID == item.roomKindID });
                                        if (roomKind != null && roomKind.length <= 0) {
                                            this.$message({
                                                message: "数据错误，请重新选择房型！",
                                                type: "error",
                                                center: true,
                                            });
                                            return;
                                        }
                                        if (roomKind[0].kindType == 1) {
                                            // 整租不需要传性别
                                            this.intentForm.sex = null;
                                        }
                                    }
                                )
                        }
                    )
            },
            ChangeRentType(item){
                this.intentForm.roomKindID = "";
                PortalApi.getIntentRoomKinds(this.intentForm.communityID, item)
                    .then(
                        (kinds) => {
                            this.roomlist = kinds.data;
                        }
                    )
            },
            ChangeStreetTown(item) {
                this.intentForm.communityID = '';
                this.intentForm.roomKindID = '';
                PortalApi.getEditCommunitys(this.intentForm.applyID, item)
                    .then(
                        (res) => {
                            this.communitylist = res.data;
                            this.roomlist = [];
                        }
                    )
            },
            changeCommunity(item) {
                this.intentForm.roomKindID = "";
                PortalApi.getIntentRoomKinds(item, this.intentForm.rentType)
                    .then(
                        (kinds) => {
                            this.roomlist = kinds.data;
                        }
                    )
            },
            changeRoomKind(item) {
                var filter = this.roomlist.filter(function (ele) { return ele.kindID == item });
                if (filter != null && filter.length > 0) {
                    if (filter[0].kindType == 1) {
                        this.intentForm.sex = null;
                    }
                    else {
                        this.intentForm.sex = this.curApply.sex;
                    }
                }
            },
            editCommunity() {
                if(this.intentForm.maritalStatus != 1 && this.intentForm.rentType == 2){
                    this.$message({
                        message: '非已婚的，租赁方式只能选择单身',
                        center: true,
                        type:"error"
                    });
                    return
                }    
                if (this.curApply.communityID == this.intentForm.communityID
                    && this.curApply.roomKindID == this.intentForm.roomKindID
                    && this.curApply.rentType == this.intentForm.rentType) {
                    this.$message({
                        message: "租赁方式、小区、房型没有变化！",
                        center: true,
                    });
                    return;
                }

                this.$refs['intentForm'].validate((valid) => {
                    if (valid) {
                        // 获取新小区户型的排号情况
                        PortalApi.getWaitingNumForPortal(this.intentForm.communityID, this.intentForm.roomKindID, this.intentForm.sex)
                            .then(
                                res => {
                                    if (res.success) {
                                        this.$confirm('您所选择的小区、户型当前排队人数为：' + res.data + '，确认更换？', '提示', {
                                            confirmButtonText: '确定',
                                            cancelButtonText: '取消',
                                            type: 'warning',
                                            closeOnPressEscape: false,
                                            closeOnClickModal: false
                                        }).then(() => {
                                            UserApi.updateApplyIntentInfo(this.intentForm.applyID, this.intentForm)
                                                .then(() => {
                                                    this.$message({
                                                        message: "小区户型变更成功",
                                                        type: "success",
                                                        center: true,
                                                    });

                                                    this.editCommunityShow = false;

                                                    // 刷新下列表
                                                    this.getApplyList();
                                                }, err => {
                                                    this.$message({
                                                        message: err,
                                                        type: "error",
                                                        center: true,
                                                    });
                                                })
                                        }).catch(() => {
                                            //this.editCommunityShow = false;
                                        });
                                    }
                                },
                                error => {
                                    this.$message({
                                        message: error,
                                        type: "error",
                                        center: true,
                                    });
                                }
                            )
                    }
                })
            },
            onPrintAccessTable(id) {
                UserApi.printAccessTable(id).then(res => {
                    if (res.data) {
                        window.open(res.data);
                    }
                }, err => {
                    this.$message.error(err);
                }).catch(error => {
                    this.$message.error(error);
                })
            },
            getUserIndo() {
                UserApi.getRentInfo().then((data) => {
                    this.applyStatus = data.data.status;
                    this.applyID = data.data.applyID;
                })
            },
            addApply(){
                // 从来没申请过的，判断一下是否是刚注册未完善基本信息的
                if((this.applylist == null || this.applylist.length == 0) && this.userInfo.sex==null || this.userInfo.sex==undefined){
                    this.$message({message:'请先完善个人基本信息',type:"warning"});
                    return false;
                }
                
                // 检查是否已经有在流程中的申请单了
                // 有就不让再填
                PortalApi.judgeUserHasApplied().then(res=>{
                    if(res.data){
                        this.$message({message:'系统中已经存在一份申请，请不要重复申请！',type:"error"});
                    }
                    else{
                        this.$router.push({ path: '/Apply' })
                    }
                })   
            },
            reApply(item){
                this.$confirm('重新申请只能申请：'+item.communityName+"："+item.roomKindsName+'，确定继续？', '系统提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    PortalApi.judgeUserHasApplied().then(res=>{
                        if(res.data){
                            this.$message({message:'系统中已经存在一份申请，请不要重复申请！',type:"error"});
                        }
                        else{
                            this.$router.push({ path: '/Apply',query:{streetTown:item.streetTown,communityId:item.communityID} })
                        }
                    })
                });                
            },
            abandon(item){
                this.warnningShow = true
            },
            closeWarn() {
                this.warnningShow = false
            },
        },
        activated() {
            this.getApplyList();
            this.getUserIndo();
            getUserInfo().then(res=>{
                this.userInfo = res;
            });
        }
    }
</script>

<style scoped>
    .maintop-menu {
        list-style: none;
        padding: 0px;
        margin: 0px 4px 0 18px;
        height: 26px;
        line-height: 26px;
    }

    .maintop-menu .normal {
        float: left;
        margin-left: 35px;
        cursor: pointer;
        color: #999999;
    }

    .active1 {
        float: left;
        margin-left: 35px;
        cursor: pointer;
        color: #333333;
        border-bottom: 2px solid #2C79CB;
    }

    .el-divider {
        margin: 0;
    }

    .person-apply {        
        margin: 41px 0 5px 0;
    }

    .person-apply-img{
        width:200px; 
        height:150px;
    }

    .person-apply-img > img{
        border: 1px solid #CCCCCC;
        width:200px; 
        height:150px;
    }

    .person-apply-content{
        height: 130px;
    }

    .person-apply-info{
        margin-left: 15px
    }

    .person-applyl-info {
        margin-left: 15px;
    }

    .person-applyl-info p {
        font-family: Source Han Sans CN;
    }

    .person-applyl-title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 18px;
    }

    .person-applyl-price {
        font-size: 18px;
        font-weight: 400;
        color: #FF0000;
        line-height: 18px;
        margin: 21px 0 20px;
    }

    .person-applyl-info span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 14px;
    }

    .person-applyl-tip {
        color: #999999;
    }

    .person-applyr{
        text-align: right;
        padding-top: 40px;
    }

    .person-applyl-blue {
        color: #2C79CB;
    }

    .grey {
        color: #999999;
    }

    .red {
        color: red;
    }

    .blue {
        color: #167CE9;
    }

    .signunits {
        display: flex;
        height: 20px;
        text-align: center;
        align-items: center;
        margin-top: 7.66px;
        margin-bottom: 10px;
    }

    .signunits .signunit {
        background: #F5F5F5;
        width: 43px;
        height: 20px;
        margin-right: 10px;
        display: flex;
        align-items: center;
    }
</style>